import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ActionTrial, CreditCardPaymentMethod, IEditionsState } from "./model";
import { SIMPLIFIED_FEATURE_KEY } from "./reducer";

export const simplifiedFeatureState = createFeatureSelector<IEditionsState>(SIMPLIFIED_FEATURE_KEY);

export const selectEditions = createSelector(simplifiedFeatureState, (state) => state.editions);

export const selectEdition = createSelector(simplifiedFeatureState, (state) => state.selectedEdition);

export const selectSelectedEditionHash = createSelector(simplifiedFeatureState, (state) => state.selectedEditionHash);

export const selectIsLoading = createSelector(simplifiedFeatureState, (state) => state.loading);

export const selectBillingCycle = createSelector(simplifiedFeatureState, (state) => state.billingCycle);

export const selectCreditCard = createSelector(simplifiedFeatureState, (state) => state.creditCard);

export const selectTotal = createSelector(simplifiedFeatureState, (state) => state.total);

export const selectTotalChargedNow = createSelector(simplifiedFeatureState, (state) => state.totalChargedNow);

export const selectBuyer = createSelector(simplifiedFeatureState, (state) => state.buyer);

export const selectCurrentStep = createSelector(simplifiedFeatureState, (state) => state.step);

export const selectAction = createSelector(simplifiedFeatureState, (state) => state.action);

export const selectTrialDays = createSelector(simplifiedFeatureState, (state) => state.selectedEdition?.trialDays);

export const selectTrialing = createSelector(
    simplifiedFeatureState,
    (state) => state.selectedEdition && state.selectedEdition.trialDays > 0 && state.action === ActionTrial
);

export const selectRequestPaymentInfo = createSelector(
    simplifiedFeatureState,
    (state) => state.selectedEdition?.paymentMethod === CreditCardPaymentMethod
);

export const selectPaymentMethod = createSelector(simplifiedFeatureState, (state) => state.paymentMethod);

export const selectAvailableAdditionalItems = createSelector(
    simplifiedFeatureState,
    (state) => state.availableAdditionalItems
);

export const selectAdditionalItems = createSelector(simplifiedFeatureState, (state) => state.additionalItems);

export const selectAdditionalProducts = createSelector(simplifiedFeatureState, (state) => state.additionalProducts);

export const selectMarketingSource = createSelector(simplifiedFeatureState, (state) => state.marketingSource);

export const selectOrderBump = createSelector(simplifiedFeatureState, (state) => state.orderBump);
